export default __webpack_public_path__ + "static/StormwaterManagement-8724ae1ef71303b3d6a627afea1c2766.jpg";